import { useContext } from "react";
import { authContext } from "../contexts/authContext";
export const useAuth = () => {
    const context = useContext(authContext);
    if (!context) throw new Error('Auth context must be use inside AuthProvider');
    return context;
}